import React from 'react';

export default function StatCard({ title, value, icon, color = '#0d6efd', bg, subtitle, trend }) {
  const bgColor = bg || `${color}15`;
  return (
    <div className="stat-card h-100">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="stat-label">{title}</div>
          <div className="stat-value">{value ?? '—'}</div>
          {subtitle && <div style={{ fontSize: 12, color: '#6c757d' }}>{subtitle}</div>}
          {trend !== undefined && (
            <div style={{ fontSize: 12, marginTop: 4 }}>
              <span style={{ color: trend >= 0 ? '#198754' : '#dc3545' }}>
                <i className={`bi bi-arrow-${trend >= 0 ? 'up' : 'down'}-short`}></i>
                {Math.abs(trend)}%
              </span>
              <span style={{ color: '#6c757d', marginLeft: 4 }}>vs last month</span>
            </div>
          )}
        </div>
        <div className="stat-icon" style={{ background: bgColor, color }}>
          <i className={`bi ${icon}`}></i>
        </div>
      </div>
    </div>
  );
}
